module.exports = __webpack_public_path__ + "static/media/pic_to_screen.92f41f92.png";